module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"from":"from","to":"to","inconsistent_dates":"inconsistent dates","equal_dates":"The end date should be greater than the start date"},"fr":{"from":"de","to":"à","inconsistent_dates":"dates incohérentes","equal_dates":"la date finale doit être supérieure à la date initiale"}}')
  delete Component.options._Ctor
}
